export const path = 'api/charts/cost_per_day'
export const method = 'get'

export default {
   'name': 'Orders from Youcan',
   'sheet_id': 'QSDfFsqdDSQDfrsqFDSRHTRzer',
   'sheet_name': 'Youcan-Orders',
   'auto_fetch': true
}